import { render, staticRenderFns } from "./openBacoAllTime.vue?vue&type=template&id=1cbf4428&"
import script from "./openBacoAllTime.vue?vue&type=script&lang=js&"
export * from "./openBacoAllTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports